import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, ButtonType } from '@riotgames/accounts-react-components';

import { WEB_BODY1_CLASS } from '@riotgames/accounts-react-components/lib/Typography';
import { Grid, GridDirection } from '@riotgames/accounts-react-components/lib/Grid';

import './banStatus.scss';

const BanStatus = ({ gameList = ['리그 오브 레전드'] }) => {
  const banStatusOfGames = gameList.map((gameName, idx) => <li key={idx}>{gameName}</li>);

  return (
    <Grid direction={GridDirection.vertical} fill={true}>
      <ul className={cx(WEB_BODY1_CLASS, 'ban-status')}>{banStatusOfGames}</ul>
    </Grid>
  );
};

export default BanStatus;
